import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 9v6h4l5 5V4l-5 5H7z"
}), 'VolumeMute');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VolumeMute.js
// module id = 7165
// module chunks = 2